import { useEffect } from "react";
import { useNavigate } from "react-router";

export const AccountPage = () => {
  const navigate = useNavigate();

  useEffect(() => {
    navigate("/account/profile");
  }, [navigate]);

  return null; // This component redirects to the profile page and does not render anything itself.
};
